import Alpine from 'alpinejs'

import widgetsPlugin from '@clickncode/widgets/plugin.mjs'
import { $u, plugin as uplandPlugin } from '@uplandjs/alpine'
import Deferred from 'p-defer'

window.Alpine = Alpine

window.$u = $u
window.Deferred = Deferred
Alpine.plugin(uplandPlugin)
Alpine.plugin(widgetsPlugin)
window.addEventListener('DOMContentLoaded', () => {
  Alpine.start()
})
